import Axios from 'axios'
import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'
import { patchWithRedirect, postWithRedirect } from 'utils/axios'

import { InnerWidgetPatchBody, TReportWidget } from 'types/GlobalWidget'
import { parseAuthenticationHeader } from 'helpers/Functions'

import { parseQueryParamForPost, QueryParams } from '..'
import { TEditLockedWidgetBody } from 'types/GlobalReport'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/reports`
const REPORT_EDITION_URL = `${BASE_URL}v1/report-editions`

export async function getOne(
  id: string,
  reportId: string,
  queryParam: QueryParams | null
) {
  return postWithRedirect<TReportWidget>(`${URL}/${reportId}/widgets/${id}`, {
    data: parseQueryParamForPost(queryParam, {
      variant: GlobalFilterVariant.ALL,
      custom_selected: [],
      company_group_id: null
    })
  })
}

export async function destroy(id: string, reportId: string) {
  return Axios.delete<{
    data: {
      id: string
      block_id: string | null
    }
  }>(`${URL}/${reportId}/widgets/${id}`, parseAuthenticationHeader())
}

export async function update(
  id: string,
  reportId: string,
  body: InnerWidgetPatchBody
) {
  return patchWithRedirect<TReportWidget>(`${URL}/${reportId}/widgets/${id}`, {
    data: body
  })
}

export async function editData(
  id: string,
  reportEditionId: string,
  body: TEditLockedWidgetBody
) {
  return patchWithRedirect<TReportWidget>(
    `${REPORT_EDITION_URL}/${reportEditionId}/widgets/${id}/locked-data`,
    {
      data: body
    }
  )
}
